import { Component, ElementRef, inject, input, model, output, signal, ViewEncapsulation } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

/**
 * Native port of the AngularJS `ftLanguageSelector` directive: the per-language preview
 * dropdown the contest sheets use to pick which language's values are shown. Toggles the
 * `active` class open/closed (close on outside click); two-way `selectedLanguage` via
 * `selectedLanguageChange`.
 */
@Component({
    selector: 'ft-language-selector-ng',
    imports: [TranslateModule],
    encapsulation: ViewEncapsulation.None,
    templateUrl: './ft-language-selector.component.html',
    host: {
        '(document:click)': 'onDocumentClick($event)',
    }
})
export class FtLanguageSelectorComponent {
    readonly languages = input<any[]>([]);
    readonly selectedLanguage = model<any>();
    readonly change = output<any>();

    protected readonly open = signal(false);

    private readonly host = inject<ElementRef<HTMLElement>>(ElementRef);

    protected toggle(event: Event): void {
        event.stopPropagation();
        this.open.update((open) => !open);
    }

    protected selectLanguage(language: any): void {
        this.selectedLanguage.set(language);
        this.change.emit(language);
        this.open.set(false);
    }

    protected onDocumentClick(event: MouseEvent): void {
        if (this.open() && !this.host.nativeElement.contains(event.target as Node)) {
            this.open.set(false);
        }
    }
}
